import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RippleModule } from 'primeng/ripple';

import { AccountFaqCategoriesComponent } from './account-faq-categories.component';

/** Website FAQs → Categories (#202). */
@NgModule({
  declarations: [AccountFaqCategoriesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DynamicDialogModule,
    InputTextModule,
    InputTextareaModule,
    RippleModule,
  ],
  exports: [AccountFaqCategoriesComponent],
})
export class AccountFaqCategoriesModule {}
